module.exports = __webpack_public_path__ + "img/close.14e36fed.png";